import "whatwg-fetch"
import React from "react"
import { Provider } from "react-redux"
import { StyleRoot } from "radium"
import { withRadium } from "higher-order-components"
import { get } from "utils"
import { IS_BROWSER } from "constants/environment"
import { BrowserRouter, StaticRouter } from "react-router-dom"
import getStore from "store"
import styles from "./app.less"
import componentParser from "AtomicUtils/componentParser"
import { WINDOW } from "AtomicUtils/environment"
import cookieHandler from "AtomicUtils/cookieHandler"
import urlHandler from "AtomicUtils/urlHandler"
import { scrollToElementId } from "AtomicUtils/scroll"
import { dispatchEvent, createNewEvent } from 'AtomicUtils/newEvent'

// React-fix-it somehow magically fixes an error of React.Net
import fixIt from "react-fix-it"

if (process.env.BABEL_ENV && process.env.BABEL_ENV === "dingo") {
  if (WINDOW) {
    window.dataLayer = []
  }
}

class App extends React.Component {

  componentDidMount(){
    setTimeout(()=>{
      this.setURLinCookie()
      this._scrollToHash()
    }, 1000)
  }


  _scrollToHash = () => {
    if (WINDOW && !WINDOW.scrollToHash ){
      WINDOW.scrollToHash = true
      WINDOW.stickyBar = false
      const hash = new urlHandler(WINDOW.location.href).getHash()
      if (hash !== '') {
        scrollToElementId(hash, {}, this._callBackOnScroll)
      } else {
        this._callBackOnScroll()
      }
    }
  }

  _callBackOnScroll = () => {
    WINDOW.stickyBar = true
    let event = createNewEvent('UPDATE_STICKY_NAV')
    dispatchEvent(event)
  }

  setURLinCookie = () => {
    if (!WINDOW) return

    let cookieHandlerObject = new cookieHandler();
    let history = cookieHandlerObject.getCookie("history");
    let newHistory = []
    if (history){
      newHistory = JSON.parse(history)
    }
    const pathname = new urlHandler(WINDOW.location.href).getPathname()

    if (
      newHistory.length
      && newHistory[newHistory.length - 1]
      && newHistory[newHistory.length - 1] === pathname
    ) return

    newHistory.push(pathname)
    if (newHistory.length > 5){
      newHistory.shift()
    }
    cookieHandlerObject.setCookie("history",JSON.stringify(newHistory))

  }

  render() {
    const { location = { search: "", pathname: "" }, components, children } = this.props
    const routerProps = IS_BROWSER
    ? {}
    : {
      context: {},
      location: get("pathname", location || {}) || "/"
    }
    const store = getStore()
    const Router = IS_BROWSER ? BrowserRouter : StaticRouter

    return (
      <Provider store={store}>
        <StyleRoot radiumConfig={{ userAgent: "all" }}>
          <Router {...routerProps}>
            <div>
              {components && componentParser(components)}
              {!components && children}
            </div>
          </Router>
        </StyleRoot>
      </Provider>
    )
  }
}

export const StoryBookApp = withRadium(fixIt)(App)

export default withRadium(fixIt)(App)



// WEBPACK FOOTER //
// ./src/containers/app/index.jsx